export const AdsAdByType = (t: any) => [
  {
    label: t('adsAdBy.theGrandMosque'),
    value: 'theGrandMosque',
  },
  {
    label: t('adsAdBy.theProphetMosque'),
    value: 'theProphetMosque',
  },
  {
    label: t('adsAdBy.other'),
    value: 'umayyadMosque',
  },
];
